// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-BMBZ","contract":"styles_contract__FsMWx","listItem":"styles_listItem__gE7rJ","transaction":"styles_transaction__Z8zal"};